import { BulkLoader } from './../../../loader/BulkLoader';
import { LoadingItem } from './../../../loader/LoadingItem';


import Event = createjs.Event;
import ErrorEvent = createjs.ErrorEvent;
import {isNullOrUndefined} from "util";

import {getLogger} from "@goodgamestudios/logger";
import {BasicModel} from "../../model/BasicModel";
import {AssetUnitVersionsProtocol} from "../data/AssetUnitVersionsProtocol";
import {PathProvider} from "../../environment/providers/PathProvider";
const logger = getLogger("core.AssetLoaderService");

export enum AssetLoadingFlowType{
    SEQUENTIAL,
    PARALLEL
}

export function loadAsset(name: string, prio: number = 0) {

    let assetInterfaceVersions: AssetUnitVersionsProtocol = PathProvider.instance.interfaceVersions;
    let assetItemVersions: AssetUnitVersionsProtocol = PathProvider.instance.itemVersions;

    if (isNullOrUndefined(assetInterfaceVersions) || isNullOrUndefined(assetItemVersions)) {
        logger.error("InterfaceVersions or ItemVersions has not been set. Set them before using assetLoad method. \n ");
    }
    return new Promise ((resolve, reject) => {

        let isInterfaceAsset: boolean = isNullOrUndefined(assetInterfaceVersions.getPath(name)) == false;
        let isItemAsset: boolean = isInterfaceAsset ? false : isNullOrUndefined(assetItemVersions.getPath(name)) == false;

        let gettingLoadingItem: Function;
        let assetType: string;

        if (isInterfaceAsset) {
            gettingLoadingItem = BasicModel.basicLoaderData.loadVersionedInterfaceAsset;
            assetType = "interface";
        }else if (isItemAsset) {
            gettingLoadingItem = BasicModel.basicLoaderData.loadVersionedItemAsset;
            assetType = "item";
        }

        if( !gettingLoadingItem ) {
            logger.warn(`Could not find Version for Interface/Item: ${name} (skipping)`);
            resolve("Warning from promise: " + name);
            return;
        }

        logger.debug(`loadAsset - ${name}, type - ${assetType},with prio - ${prio}`);
        let loadingItem: LoadingItem = gettingLoadingItem.apply(BasicModel.basicLoaderData, [ name, prio ]);

        if (loadingItem.isLoaded) {
            logger.debug(`${name} was loaded already!`);
            resolve(name);
        } else {
            logger.debug(`loading of ${name} has been started`);
            const onAssetLoaded = (e) => {
                removeListeners();
                resolve(e);
                logger.debug(`loading of ${name} has been finished`);
            };
            const onError = (e: ErrorEvent) => {
                removeListeners();
                resolve(e);
                logger.warn(`loading of ${name} has been canceled with error`);
            };
            const removeListeners = () => {
                loadingItem.removeEventListener(Event.COMPLETE, onAssetLoaded);
                loadingItem.removeEventListener(BulkLoader.ERROR, onError);
            }

            loadingItem.addEventListener(Event.COMPLETE, onAssetLoaded, false, 0, true);
            loadingItem.addEventListener(BulkLoader.ERROR, onError, false, 0, true);
        }
    });
}

export function loadAssets(list: Array<any>, flowType: AssetLoadingFlowType = AssetLoadingFlowType.PARALLEL, prio: number = 0 ): Promise<any>{
    logger.debug(`loadAssets list - ${list}, flowType: ${flowType}, prio: ${prio}`);
    if (flowType == AssetLoadingFlowType.PARALLEL) {
        return Promise.all( list.map( (assetName: string) => loadAsset(assetName, prio) ) );
    }else if (flowType == AssetLoadingFlowType.SEQUENTIAL) {
        let allResults = [];
        return list.reduce((promise, assetName) => {
            return promise
                .then( (result) => {
                    return loadAsset(assetName, prio).then(
                        result => allResults.push(result)
                    );
                } )
        }, Promise.resolve());
    }
    return null
}
